<script>
    import SortableListCardEdit from './SortableListCard_Edit.svelte';
    import ListItemEdit from './ListItem_Edit.svelte';
    import {Input, Slider, MultiSelect} from '../components/ui';
    import {productMainTypes} from '../definitions/Lists';

    import {education, seniority} from '../definitions/Lists';

    export let model;
    export let isEdit = false;
    let test = [];

</script>

<div>
    <div class="flex flex-row mt-4 mb-4">
        <Input bind:model={model.targetMarketSegment} label="Target Market Segment" class="flex-grow mr-2"/>
        <Input bind:model={model.roles} label="Roles" class="flex-grow ml-2"/>
    </div>
    <div class="flex flex-row mt-4 mb-4">
        <MultiSelect bind:model={model.offer} list={productMainTypes} class="w-1/2 col-span-6 sm:col-span-3" label="What's your offer"/>
    </div>

    <div class="mt-4 mb-4 p-8">
        <Slider bind:model={model.education} entryList={education} />
    </div>

       <div class="mt-4 mb-4 p-8">
        <Slider bind:model={model.seniority} entryList={seniority} />
    </div>
    {#if !isEdit}
    <div class="overflow-auto">
        <div class="w-1/3 float-left">
            <SortableListCardEdit bind:model={model.pjg.pains} class="p-4"/>
        </div>
        <div class="w-1/3 float-left">
            <SortableListCardEdit bind:model={model.pjg.jobs} class="p-4"/>
        </div>
        <div class="w-1/3 float-left">
            <SortableListCardEdit bind:model={model.pjg.gains} class="p-4"/>
        </div>
    </div>
    {/if}
</div>